import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

export const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (!onClose) return;
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const icons = {
    success: <CheckCircle className="w-4 h-4 text-emerald-500" />,
    error: <AlertCircle className="w-4 h-4 text-rose-500" />,
    warning: <AlertTriangle className="w-4 h-4 text-amber-500" />,
    info: <Info className="w-4 h-4 text-blue-500" />,
  };

  const colors = {
    success: 'border-l-4 border-l-emerald-500 border-slate-200 bg-white text-slate-800',
    error: 'border-l-4 border-l-rose-500 border-slate-200 bg-white text-slate-800',
    warning: 'border-l-4 border-l-amber-500 border-slate-200 bg-white text-slate-800',
    info: 'border-l-4 border-l-blue-500 border-slate-200 bg-white text-slate-800',
  };

  return createPortal(
    <div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-right-10 duration-300">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-xl border shadow-[0_10px_30px_rgba(0,0,0,0.08)] backdrop-blur-md ${colors[type] || colors.info}`}>
        {icons[type] || icons.info}
        <span className="text-[13px] font-semibold text-slate-700 tracking-tight">{message}</span>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-2 p-1 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
          >
            <X className="w-3.5 h-3.5 opacity-50" />
          </button>
        )}
      </div>
    </div>,
    document.body
  );
};

export default Toast;
